import React from 'react';

import { TooltipPortal } from '~components';

import { CompanyAccessKey } from '~main/models';

interface ComponentProps {
  rowData?: CompanyAccessKey;
}

const AccessTags: React.FC<ComponentProps> = ({ rowData }) => {
  const tags = rowData?.tags || [];
  if (!rowData || !rowData?.tags || rowData?.tags.length === 0) {
    return <div>N / A</div>;
  }

  const firstThreeTags = tags.slice(0, 3);
  const hasMoreTags = tags.length > 3;

  const tooltipId = `access-tags-${rowData.id}`;

  const renderTooltipContent = () => {
    if (tags.length <= 5) {
      return (
        <div>
          {tags.map((tag, index) => (
            <div key={tag.id || index}>{tag.tag.access_tag}</div>
          ))}
        </div>
      );
    }

    const firstFiveTags = tags.slice(0, 5);
    const remainingCount = tags.length - 5;

    return (
      <div>
        {firstFiveTags.map((tag, index) => (
          <div key={tag.id || index}>{tag.tag.access_tag}</div>
        ))}
        <div>and {remainingCount} more...</div>
      </div>
    );
  };

  return (
    <div>
      {firstThreeTags.map((tag, index) => (
        <div key={tag.id || index}>{tag.tag.access_tag}</div>
      ))}
      {hasMoreTags && (
        <>
          <span id={tooltipId}>...</span>
          <TooltipPortal targetId={tooltipId} content={renderTooltipContent()} placement="top" />
        </>
      )}
    </div>
  );
};

export default AccessTags;
